import { queryParamsToObject } from './query-params.utils';

export const getRouteSegmentsAndQueryParams = (url: string) => {
	const route = url?.split('?');
	const segments = route[0]?.split('/').filter(Boolean);
	const queryParams = queryParamsToObject(route[1]) || {};

	return { segments, queryParams };
};

export function getCourseSearchSegments(
	isHECoSSubject: boolean,
	degree: string | undefined,
	searchTerm: string,
	location?: string | undefined,
) {
	const subject = searchTerm?.trim().replace(/ /g, '-').toLowerCase();

	if (degree === 'clearing') {
		return new Set(['/courses', 'clearing', subject].filter(Boolean));
	}

	return isHECoSSubject
		? new Set(['/courses', 'degrees', degree, subject, location].filter(Boolean))
		: new Set(['/courses', 'search', degree, location].filter(Boolean));
}

export const getSegmentsWithClearing = (
	subject: string | undefined,
	location: string | undefined,
) => {
	return new Set(['/courses', 'clearing', subject, location].filter(Boolean));
};
